import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'fileSize'})
export class FileSizePipe implements PipeTransform {
   transform(n: number): string {
      if (isNaN(n)) {
         return 'n/a';
      }
      if (n < 1024) {
         return this.getByte(n);
      }
      if (n < 1048576) {
         return this.toFixed(n / 1024, 1) + ' KB';
      }
      if (n < 1073741824) {
         return this.toFixed(n / 1048576, 2) + ' MB';
      }
      return this.toFixed(n / 1073741824, 2) + ' GB';
   }

   private getByte(n: number) {
      const lang = localStorage.getItem('lang') || 'en';
      if (lang === 'th') {
         return n + ' ไบต์';
      }
      return n < 2 ? n + ' byte' : n + ' bytes';
   }

   private toFixed(n: number, fractionDigits: number): string {
      return n.toFixed(fractionDigits).replace(/([0-9]+(\.[0-9]+[1-9])?)(\.?0+$)/, '$1');
   }
}
